module.exports = __webpack_public_path__ + "static/img/iconArticle.1ba314a.png";